import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchCart } from "../../Utils/Redux/CartSlice";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import TopTitleBar from "../DashBoard/ExternalDash/TopTitleBar";
import { ADD_MONEY, BASE_URL, EXPORT_TRANSACTION_HISTORY, VERIFY_WALLET } from "../../Utils/constant";
import cogoToast from "cogo-toast-react-17-fix";
import { MESSAGE } from "../../Utils/Strings";
import Records from "./records";
import API from '../../ApiConfig'
import Pagination from "../DashBoard/ExternalDash/Pagination";
import AnimatedLoader from "../../components/AnimationLoader";
import { convertDateFormat } from "../../Utils/helper";
import Loader from "../../components/Loader";
import { AuthConsole } from "../../Utils/helper";

const WalletDetails = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const wallet = useSelector((state) => state.cart.wallet);
    const User = useSelector(state => state.User)
    const [data, setData] = useState({})
    const [sortBy, setSortBy] = useState(5)
    const [orderBy, setOrderby] = useState(true)
    let lables = ['total_amount', 'description', 'transaction_id', 'status', 'payment_method', 'created_at', 'wallet_balance', 'credit','debit']
    const UserDetails=useSelector(state=>state.cart.user)
    // pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const walletAmount=User.user_type=="Verifier"?wallet.balance:wallet.credits
    const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
    const [pdfLoading, setPDFLoading]=useState(false)
    const handlePageChange = (nextPage) => {
        setCurrentPage(nextPage);
    }

    useEffect(() => {
        if (!document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    const initiateRazorpayPayment = async () => {
        setLoading(true)
        try {
            const response = await fetch(`${BASE_URL}${ADD_MONEY}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: User.user_id,
                    amount
                })
            });

            const order = await response.json();
            if (!response.ok) {
                setLoading(false)
                throw new Error(order.message || "Failed to initiate payment");
            }
            return new Promise((resolve, reject) => {
                const options = {
                    key: order.data.key_id,
                    amount: order.data.amount,
                    currency: wallet.currency,
                    name: "AuthNumber",
                    description: order.data.description,
                    order_id: order.data.razorpay_order_id,
                    handler: async function (response) {
                        // Step 3: Verify Payment on Backend
                        const verifyResponse = await fetch(`${BASE_URL}${VERIFY_WALLET}`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                user_id: User.user_id,
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature
                            })
                        });

                        const result = await verifyResponse.json();
                        if (verifyResponse.ok) {
                            setLoading(false)
                            resolve(true); // Payment success
                        } else {
                            setLoading(false)
                            resolve(false); // Payment failed
                        }
                    },
                    modal: {
                        ondismiss: function () {
                          setLoading(false);
                          // Cancel the transaction when payment dialog is closed
                          fetch(`${BASE_URL}api/v1/payment/cancel-transaction`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                              razorpay_order_id: order.data.razorpay_order_id
                            })
                          })
                          .then(response => response.json())
                          .then(result => {
                            AuthConsole("Transaction cancelled:", result);
                            window.location.reload()
                          })
                          .catch(error => {
                            console.error("Error cancelling transaction:", error);
                          });
                          resolve(false);
                        }
                      },
                    prefill: {
                        name: UserDetails?.name,
                        email: UserDetails?.email,
                        contact: UserDetails?.phone_number
                    },
                    theme: { color: "#3399cc" }
                };

                const rzp1 = new window.Razorpay(options);
                rzp1.open();
            });
        } catch (error) {
            setLoading(false)
            console.error("Payment initiation error:", error);
            return false;
        }
    }

    const [amount, setAmount] = useState(wallet.currency=="USD"?100:1000)

    useEffect(() => {
        fetchTransactionHistory()
        dispatch(fetchCart(User.user_id));
    }, []);

    useEffect(() => {
        fetchTransactionHistory()
    }, [currentPage, orderBy])

    const AddMoneyToWallet = async () => {
        if(wallet.currency==="USD"){
            if(amount>=1 && amount<=100){
                const response = await initiateRazorpayPayment(amount, User.user_id)
                if (response) {
                    window.location.reload()
                }
            }
            else {
                cogoToast.error("Invalid amount! You can add between $1 to $100")
        }
    }
        else if(wallet.currency!=="USD"){
         if (amount >=1 && amount <= 25000) {
            const response = await initiateRazorpayPayment(amount, User.user_id);
            if (response) {
                window.location.reload()
            }
        }
            else {
                cogoToast.error(`Invalid amount! You can add between ${ wallet.currency=="USD"?'$1':'₹1'} to ${ wallet.currency=="USD"?'$100':'₹25000'}`)
            }
        }
    };

    const setOrder = (sort) => {
        if (sort == sortBy) {
            setOrderby(!orderBy)
        }
        else {
            setSortBy(sort)
            setOrderby('desc')
        }
    }

    const fetchTransactionHistory = () => {
        const GET_TRANSACTION_HISTORY = '/api/v1/payment/get-transaction-history/'
        const filters = `?sort_by=${lables[sortBy]}&sort_order=${orderBy ? 'desc' : 'asc'}&page=${currentPage}`
        API.get(GET_TRANSACTION_HISTORY + User.user_id + filters)
            .then(res => {
                if (res.data.status === 200) {
                    setData(res.data.data)
                    setCurrentPage(res.data.data.current_page)
                    setTotalPages(res.data.data.total_pages)
                }
            })
            .catch(err => {
                cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
            })
    }
    const handleDateChange = (field, e) => {
        setDateRange((prev) => ({ ...prev, [field]: e }));
      }
      const handleDownload = async (e) => {
        e.preventDefault();
        setPDFLoading(true);
      
        if (dateRange.startDate !== "" && dateRange.endDate !== "") {
      
          const fileName = `${dateRange.startDate}_to_${dateRange.endDate}.xlsx`;
      
          API.get(EXPORT_TRANSACTION_HISTORY + User.user_id, {
            params: {
              start_date: convertDateFormat(dateRange.startDate),
              end_date: convertDateFormat(dateRange.endDate),
            },
            responseType: "blob",
          })
            .then((res) => {
              if (res.status === 200) {
      
                const blob = new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
      
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
      
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
      
                // reset after download
                setDateRange({ startDate: "", endDate: "" });
                fetchTransactionHistory();
              }
            })
            .catch(
              async (err) => {
                                if (err.response?.data instanceof Blob) {
                                  const text = await err.response.data.text();
                                  const json = JSON.parse(text);
                                  cogoToast.error(json.message);
                                } else {
                                  cogoToast.error("Something went wrong");
                                }
                            })
            .finally(() => {
              setPDFLoading(false);
            });
      
        } else {
          setLoading(false);
          cogoToast.error("Enter Valid Start and End Date");
        }
      };
      
    return (
        <SlideUpWrapper>
        {pdfLoading?<Loader isOpen={loading}/> :   <AnimatedLoader isOpen={loading} loadingText={"Processing your payment"}/>}
            <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'>Your Wallet</span></h2></TopTitleBar>
            <section className="table-header6 " style={{ justifyContent: "center", alignItems: 'center' }}>
                <div>
                    <h1 className="heading">
                        Balance: {`${wallet.currency=="USD"?"$":"₹"}${walletAmount}`}
                    </h1>
                {User.user_type=="Issuer"?null:    <div className="table-header6 ">
                        <div className="issuer-input-wrapper">
                            <input type="number" className="issuer-input" value={amount} min={0} max={25000} onChange={e => setAmount(e.target.value)}></input>
                        </div>
                        <button onClick={AddMoneyToWallet} className="btn btn-primary">Add Money</button>
                    </div>}


                </div>
            </section>
        <div className="mb-10 flex justify-between">
        <div>
        <label className="font-bold">Start Date:</label>
            <input
                          type="date"
                          className="datePicker"
                          value={dateRange.startDate}
                          style={{ margin: "10px 25px 0px 25px" }}
                          onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
                        />
        <label className="font-bold">End Date:</label>
                        <input
                          type="date"
                          className="datePicker"
                          value={dateRange.endDate}
                          style={{margin:"10px 25px 0px 25px"}}
                          onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
                        />
        </div>
        <div>
            <button className="btn btn-primary" onClick={(e)=>handleDownload(e)}>Export transactions</button>
        </div>
        </div>
            {(data && data.items) && <Records lable={lables} data={data.items} orderBy={orderBy} sortBy={sortBy} setOrder={setOrder} />}
            <div style={{ margin: "10px" }}>
                <Pagination
                    nPages={totalPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onPageChange={handlePageChange}
                    loading={loading}
                />
            </div>
        </SlideUpWrapper>
    );
};

export default WalletDetails;